import { render, staticRenderFns } from "./MDview.vue?vue&type=template&id=cf23b6e2"
import script from "./MDview.vue?vue&type=script&lang=js"
export * from "./MDview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports